import React from "react";
import { ReportHeader } from "./ReportHeader";
import "./ReportPrintDocument.css";

export function ReportPrintHeader(props) {
  return <ReportHeader variant="print" {...props} />;
}
